import { appsignal } from './appsignal'

// Track turbo:frame-missing errors
//
// This event is fired when a frame response lacks a matching <turbo-frame> element.
// This typically indicates a server-side rendering issue or misconfigured frame ID.
//
// See: https://turbo.hotwired.dev/reference/events
document.addEventListener('turbo:frame-missing', (event) => {
  const frame = event.target
  const frameId = frame.id || 'unknown'
  const response = event.detail?.response

  appsignal.sendError(
    new Error(`Turbo frame missing: ${frameId}`),
    (span) => {
      span.setAction('turbo:frame-missing')
      span.setTags({
        frame_id: frameId,
        response_status: response?.status?.toString() || 'unknown',
        response_url: response?.url || 'unknown'
      })
    }
  )
})
